
export class LogParam {
fieldKind: string;
logField: string;
order: number | null;
targetField: string;
}

